const { InnerBlocks } = wp.blockEditor;

export default ({ attributes }) => {
  return (
    <div className="about-us-cards-swiper__card swiper-slide">
      <img
        className="about-us-cards-swiper__card--image"
        title={attributes.cardImage.alt}
        src={attributes.cardImage.src}
        alt={attributes.cardImage.alt}
      />
      <InnerBlocks.Content />
    </div>
  );
};
